import { Text } from '@cad-arc';
import { BaseCellStyledBox } from './base-cell-styled-box';
import { Tooltip } from '../tooltip';

export const FrTooltipCell = ({ text }: { text: string | undefined }) => {
    return (
        <BaseCellStyledBox>
            <Tooltip overlay={text}>
                <Text style={{
                    overflow: 'hidden',
                    textOverflow: 'ellipsis',
                    textWrap: 'nowrap',
                }}>
                    {text}
                </Text>
            </Tooltip>
        </BaseCellStyledBox>
    );
}

